module.exports = __webpack_public_path__ + "static/media/acorn-copy.33e91da1.svg";